<template>
  <input
      @input="handleInput"
      @keydown="handleKeydown"
      @change="handleChange"
      @blur="handleChange"
  />
</template>

<script setup>
import { defineProps,defineEmits } from 'vue'
const emit = defineEmits(['update:modelValue'])

const props = defineProps({
  modelValue: {
    type: Number,
    required: true
  },
  max: {
    type:Number,
    default: Infinity,
  },
  min: {
    type:Number,
    default: -Infinity,
  }
})
  function handleKeydown(e) {
    const val = e.target.value + e.key
    if (e.key.length === 1 && !e.metaKey && !e.ctrlKey && !e.altKey && (
      !/[0-9.,-]/.test(e.key) ||
      val.split('.').length > 2 ||
      val.split(',').length > 2 ||
      val.split('-').length > 2 ||
      (val.indexOf('.') !== -1 && val.indexOf(',') !== -1) ||
      (val.indexOf('-') !== -1 && val.indexOf('-') !== 0)
    )) {
      e.preventDefault()
    }
  }

  function handleInput(e){
    let val = e.target.value
    if (val === '.'){
      val = '0.'
    } else if (val === ','){
      val = '0,'
    } else if (val !== '-' && val[val.length - 1] !== '.' && val[val.length - 1] !== ',' && (!val.match(/[.,]/) || val[val.length - 1] !== '0') && val !== '') {
      val = Math.min(Math.max(parseFloat(val.replace(',','.')), props.min), props.max)
    }
    if (e.target.value.match(/,/)) {
      val = val.toString().replace(/\./, ',');
      e.target.dispatchEvent(new Event('change', { bubbles: true }));
    }
    e.target.value = val
  }

  function handleChange (e){
    e.target.value = e.target.value.replace(/[-.,]$/, '').replace(/^-$/,'')
    const number = Number(e.target.value.toString().replace(/,/, '.'))
    if (e.target.value.match(/,/)) {
      e.target.value = number.toString().replace(/\./, ',');
    }else{
      e.target.value = number
    }
    emit('update:modelValue', number)
  }
</script>

<style scoped>
  input {
    width: 100%;
  }
</style>